module.exports = __webpack_public_path__ + "static/media/GothamRnd-Bold.56fbddbf.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/GothamRnd-Bold.woff
 ** module id = 1346
 ** module chunks = 0
 **/